'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _react = require('react');
var _react2 = _interopRequireDefault(_react);
var _propTypes = require('prop-types');
var _propTypes2 = _interopRequireDefault(_propTypes);
require('./KeyValueList.css');
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

/**
 * Item containing both the key and value to display inside KeyValueList
 */
var KeyValueListItem = function KeyValueListItem(_ref) {
  var k = _ref.k,
    v = _ref.v;
  return _react2.default.createElement('div', {
    className: 'c-key-value'
  }, _react2.default.createElement('div', {
    className: 'c-key-value__k'
  }, k), _react2.default.createElement('div', {
    className: 'c-key-value__v'
  }, v));
};
KeyValueListItem.propTypes = process.env.NODE_ENV !== "production" ? {
  /** Key to display on the left */
  k: _propTypes2.default.oneOfType([_propTypes2.default.arrayOf(_propTypes2.default.node), _propTypes2.default.node]),
  /** Value to display on the right */
  v: _propTypes2.default.oneOfType([_propTypes2.default.arrayOf(_propTypes2.default.node), _propTypes2.default.node])
} : {};
exports.default = KeyValueListItem;